


















import Vue, { PropOptions } from 'vue';
interface Props {
  title: PropOptions;
  subtitle: PropOptions;
  icon: PropOptions;
}

export default Vue.extend({
  name: 'ProductTypeCard',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    locked: {
      type: Boolean,
      default: false,
    },
  } as Props,
});
